module.exports = __webpack_public_path__ + "static/media/Boeing_full_logo.63cdf493.svg";